import { cn } from "@/lib/utils";
import { BaseEntryValue } from "./BaseEntryValue";
import type { BaseEntryValueProps } from "./BaseEntryValue";

export interface DefaultEntryValueProps
	extends Omit<BaseEntryValueProps, "value"> {
	value: string | null;
}

export function DefaultEntryValue({
	value,
	inputLabel,
	size,
	className,
	...props
}: DefaultEntryValueProps) {
	return (
		<BaseEntryValue
			inputLabel={inputLabel}
			size={size}
			className={className}
			{...props}
		>
			<p
				className={cn(
					size === "sm" ? "text-sm" : size === "lg" ? "text-lg" : "text-base",
				)}
			>
				{value ?? "None"}
			</p>
		</BaseEntryValue>
	);
}
